import { render, staticRenderFns } from "./RecordUserFile.vue?vue&type=template&id=61f383b2&"
import script from "./RecordUserFile.vue?vue&type=script&lang=js&"
export * from "./RecordUserFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports